(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brick-calculator"] && !Shopify.designMode) return;
  try {
    
  
        $(document).ready(function(){
        
        $('#calculator_btn').on('click',function(){
			$('.popup-wrap').fadeIn(500);
		});

    	$('.popup .btn-close').on("click",function(){
			$('.popup-wrap').fadeOut(500);
		});

        //Display Corners fields
        $('#hasCorners').on('change',function(){
          if($(this).val() == "yes"){
            $('#cornersDiv').show();
          }else{
            $('#brickwebb-corners-length').val(0);
            $('#brickwebb-corners-num').val(0);
            calculate('brickwebb-corners');
            $('#thinbrick-corners-length').val(0);
            $('#thinbrick-corners-num').val(0);
            calculate('thinbrick-corners');
            $('#cornersDiv').hide();
            
          }
        });
        

        //calculate brickwebb
        $('#brickwebb-length').on('change',function(){calculate('brickwebb')});
        $('#brickwebb-width').on('change',function(){calculate('brickwebb')});

        //calculate herringbone
        $('#herringbone-length').on('change',function(){calculate('herringbone')});
        $('#herringbone-width').on('change',function(){calculate('herringbone')});

        //calculate thinbrick singles
        $('#thinbrick-length').on('change',function(){calculate('thinbrick')});
        $('#thinbrick-width').on('change',function(){calculate('thinbrick')});

        //calculate brickwebb corners
        $('#brickwebb-corners-length').on('change',function(){calculate('brickwebb-corners')});
        $('#brickwebb-corners-num').on('change',function(){calculate('brickwebb-corners')});

        //calculate thin brick corners
        $('#thinbrick-corners-length').on('change',function(){calculate('thinbrick-corners')});
        $('#thinbrick-corners-num').on('change',function(){calculate('thinbrick-corners')});
  
        //recalculate all if 10% is changed
        $('#tenPct').on('change',function(){
          calculate('brickwebb');
          calculate('herringbone');
          calculate('thinbrick');
          calculate('brickwebb-corners');
          calculate('thinbrick-corners');
        });

        $('#measure_type').on('change',function(){
          $('.measure_type').html('('+this.value+')');
          calculate('brickwebb');
          calculate('herringbone');
          calculate('thinbrick');
          calculate('brickwebb-corners');
          calculate('thinbrick-corners');
        });
          
        //apply quantities
        $('#applyQty').on('click',function(event){
          event.preventDefault();
          //set brickweb
          $('input[data-var-type="brickwebb"]').val($('#brickwebb-boxes').html());
          
          //set brickweb corners
          $('input[data-var-type="brickwebb-corners"]').val($('#brickwebb-corners-boxes').html());
          
          //set thin brick
          $('input[data-var-type="thinbrick"]').val($('#thinbrick-boxes').html());
          
          //set thin brick corners
          $('input[data-var-type="thinbrick-corners"]').val($('#thinbrick-corners-boxes').html());

          //set herringbone
          $('input[data-var-type="herringbone"]').val($('#herringbone-boxes').html());
          
          //close popup
          $('.popup-wrap').fadeOut(500);
          submitAddToCartForm(document.querySelector('.custom-product-form'));
          //document.querySelector('.custom-product-form').submit();
        });
  
	});

  function calculate(id){
    var tenPct = $('#tenPct').is(':checked'); 
    var prodSF = 1;
    var widthOrNum = "width";
    var measureType = $('#measure_type').val();
    var divisor1 = 1;
    var divisor2 = 1;
    if(measureType == 'in'){divisor1 = 12; divisor2 = 12;}
    switch(id){
      case "brickwebb":
        prodSF = 8.7;
        break;
      case "herringbone":
        prodSF = 8.7;
        break;
      case "thinbrick":
        prodSF = 7.3;
        break;
      case "thinbrick-corners":
        prodSF = 5.5;
        widthOrNum = "num";
        divisor2 = 1;
        break;
      case "brickwebb-corners":
        prodSF = 5.3;
        widthOrNum = "num";
        divisor2 = 1;
        break;
      default:
        prodSF = 1;
    }  
  
    var sqFt = ($('#'+id+'-length').val()/(divisor1)) * ($('#'+id+'-'+widthOrNum).val()/(divisor2));
    if(tenPct == true){sqFt=sqFt*1.1;}
    $('#'+id+'-sf').html(Math.round(sqFt*100)/100);
    $('#'+id+'-boxes').html(Math.ceil(sqFt/$('#'+id+'-sqft').val()));
  }

  } catch(e) { console.error(e); }
})();
})();
